import { c as _c } from "react/compiler-runtime";
import { MaterialIcon, MaterialNameType } from "@website/icons/material";
import type { Country } from "@website/ticket-ui/visa/types";
import { numberConvert } from "@website/utils/number-convert";
type BoxProperties = {
  title: string;
  detail: string;
  iconName: MaterialNameType;
};
const Box = t0 => {
  const $ = _c(12);
  const {
    title,
    detail,
    iconName
  } = t0;
  let t1;
  if ($[0] !== iconName) {
    t1 = <div className="text-on-surface-medium-emphasis text-2xl"><MaterialIcon name={iconName} /></div>;
    $[0] = iconName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = <div className="text-on-surface-high-emphasis text-subtitle-2 mb-1">{title}</div>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== detail) {
    t3 = <div className="text-on-surface-medium-emphasis text-caption md:text-button md:text-center">{detail}</div>;
    $[4] = detail;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div>{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t4) {
    t5 = <div className="border-outline-thin elevation-1 flex h-[76px] items-center gap-x-4 rounded-xl border p-4 md:h-auto md:flex-1 md:flex-col md:gap-6">{t1}{t4}</div>;
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export type BoxesProperties = {
  countryDetails: Country["details"];
};
export const Boxes = t0 => {
  const $ = _c(21);
  const {
    countryDetails
  } = t0;
  const {
    validityPeriod,
    normalVisaProcessDuration,
    urgentVisaProcessDuration
  } = countryDetails;
  let t1;
  if ($[0] !== validityPeriod) {
    t1 = () => `${numberConvert(validityPeriod, {
      locale: "fa"
    })} روز`;
    $[0] = validityPeriod;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getValidityText = t1;
  let t2;
  if ($[2] !== normalVisaProcessDuration.maximum || $[3] !== normalVisaProcessDuration.minimum) {
    t2 = () => {
      const min = numberConvert(normalVisaProcessDuration.minimum, {
        locale: "fa"
      });
      const max = numberConvert(normalVisaProcessDuration.maximum, {
        locale: "fa"
      });
      return `${min} تا ${max} روز کاری`;
    };
    $[2] = normalVisaProcessDuration.maximum;
    $[3] = normalVisaProcessDuration.minimum;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const getNormalText = t2;
  let t3;
  if ($[5] !== urgentVisaProcessDuration?.maximum || $[6] !== urgentVisaProcessDuration?.minimum) {
    t3 = () => {
      const min_0 = numberConvert(urgentVisaProcessDuration?.minimum, {
        locale: "fa"
      });
      const max_0 = numberConvert(urgentVisaProcessDuration?.maximum, {
        locale: "fa"
      });
      return `${min_0} تا ${max_0} روز کاری`;
    };
    $[5] = urgentVisaProcessDuration?.maximum;
    $[6] = urgentVisaProcessDuration?.minimum;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const getUrgetText = t3;
  let t4;
  if ($[8] !== getValidityText || $[9] !== validityPeriod) {
    t4 = validityPeriod && <Box detail={getValidityText()} iconName="event" title={"\u0645\u062F\u062A \u0632\u0645\u0627\u0646 \u0627\u0639\u062A\u0628\u0627\u0631 \u067E\u0633 \u0627\u0632 \u0635\u062F\u0648\u0631"} />;
    $[8] = getValidityText;
    $[9] = validityPeriod;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== getNormalText || $[12] !== normalVisaProcessDuration) {
    t5 = normalVisaProcessDuration && <Box detail={getNormalText()} iconName="schedule" title={"\u0632\u0645\u0627\u0646 \u067E\u0631\u062F\u0627\u0632\u0634 \u0648\u06CC\u0632\u0627\u06CC \u0639\u0627\u062F\u06CC"} />;
    $[11] = getNormalText;
    $[12] = normalVisaProcessDuration;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== getUrgetText || $[15] !== urgentVisaProcessDuration) {
    t6 = urgentVisaProcessDuration && <Box detail={getUrgetText()} iconName="av_timer" title={"\u0632\u0645\u0627\u0646 \u067E\u0631\u062F\u0627\u0632\u0634 \u0648\u06CC\u0632\u0627\u06CC \u0641\u0648\u0631\u06CC"} />;
    $[14] = getUrgetText;
    $[15] = urgentVisaProcessDuration;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t4 || $[18] !== t5 || $[19] !== t6) {
    t7 = <div className="flex flex-col gap-y-4 md:flex-row md:gap-x-10">{t4}{t5}{t6}</div>;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};